import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // `pathname` will be the current URL path (e.g., "/menu", "/store")
  const { pathname } = useLocation();

  // This effect will run every time the `pathname` changes
  useEffect(() => {
    // This command scrolls the window to the top left corner
    window.scrollTo(0, 0);
  }, [pathname]); // The dependency array ensures the effect runs on route change

  // This component doesn't render any visible JSX
  return null;
};

export default ScrollToTop;